
import { LayoutContainer } from "@common";
import { Separator } from "../ui/separator";

export const Footer = () => {

  return (
    <div className="flex flex-col text-left">
      <Separator />
      <LayoutContainer >
        <p className=" leading-8 text-[1rem] font-semibold">Aissa Nadjem eddine © 2024</p>
      </LayoutContainer>
    </div>
  );
};
